import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  ListGroup,
  Badge,
  Alert,
} from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const Content = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const storedUser = JSON.parse(localStorage.getItem("user"));
const customerId = storedUser?.id || null; // null if not found


  useEffect(() => {
    // 💡 Axios automatically handles formatting the `params` object into a query string.
    // The request URL will become: http://your-api.com/user/content-access?customer_id=18
    axios
      .get(`${API_BASE_URL}/user/content-access`, {
        params: {
          customer_id: customerId,
        },
      })
      .then((response) => {
        setOrders(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("API Error:", error);
        setLoading(false);
      });
  }, [API_BASE_URL, customerId]);

  if (loading) return <p>Loading...</p>;

  const hasValidAccess = orders.some((order) => order.remaining_days > 0);

  return (
    <Container className="mt-4">
      <Row className="mb-3 align-items-center">
        <Col>
          <h1 className="mb-0">Content Page</h1>
        </Col>
        <Col className="text-end">
          {hasValidAccess && (
            <Button href="/content/all" className="btn-default">
              Go to Content
            </Button>
          )}
        </Col>
      </Row>

      {!orders.length && (
        <div className="text-center my-5">
          <Link to="/content" className="btn-default">Buy Content</Link>
        </div>
      )}

      {orders.length > 0 && (
        <>
          <h4 className="mb-3">Your Orders:</h4>
          <ListGroup>
            {orders.map((order, index) => (
              <ListGroup.Item
                key={index}
                className="d-flex justify-content-between align-items-center"
                style={{
                  fontFamily:
                    "'Poppins', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                  fontSize: "2rem",
                  padding: "0.75rem 1.25rem",
                  borderRadius: "6px",
                  marginBottom: "0.5rem",
                  boxShadow: "0 1px 3px rgb(0 0 0 / 0.1)",
                }}
              >
                <div>
                  <strong>Order Date:</strong> {order.order_date}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <strong>Remaining Days:</strong>{" "}
                  <span
                    style={{
                      fontWeight: "600",
                      color: order.remaining_days === 0 ? "#dc3545" : "#198754",
                    }}
                  >
                    {order.remaining_days}
                  </span>
                  {order.remaining_days === 0 ? (
                    <Badge bg="danger" pill>
                      Expired
                    </Badge>
                  ) : (
                    <Badge bg="success" pill>
                      Active
                    </Badge>
                  )}
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </>
      )}

      {!hasValidAccess && orders.length > 0 && (
        <Alert variant="warning" className="mt-3">
          Access denied. Your content subscription has expired.
        </Alert>
      )}
    </Container>
  );
};

export default Content;